var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-index-panel",class:_vm.panelClasses,style:(_vm.panelStyle),attrs:{"id":`panel-${_vm.panelSide}`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }